import React, { Component } from 'react';
import { isMobileOnly } from "react-device-detect";

import { ValidatorUtils } from '../utils';
import logo from '../assets/logo-icon.png';
import { History as history, Routes as routes } from '../navigation';
import { Button, Input, PhoneInput, Line } from '../components';
import '../css/SignIn.css';

class SignIn extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      phone_number: '',
      validation: {},
      email_loading: false,
      phone_loading: false,
    }
  }

  performSignIn = () => {
    this.props.userActions.signIn(this.state.email, this.state.password, this.updateErrorMessage);
  }

  render() {
    let width  = isMobileOnly ? 340 : 420;
    let errors = this.state.validation && this.state.validation.errors ? this.state.validation.errors : [];

    return (
      <div className="standard-container flex-container-column" style={{ alignItems: 'center', minWidth: width, width: width, maxWidth: width, height: 385, maxHeight: 385 }}>
        <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 35, marginBottom: 15 }}>
          <img className="sign-in-logo-image" src={logo} alt="Icon Text" />
          <span style={{ marginTop: 2, fontSize: 28, fontWeight: '600', color: '#1dc2ff' }}>teletails</span>
        </div>

        <div className='flex-container-column'>
          <div style={{ paddingLeft: 3, marginBottom: 2 }}>
            <span style={{ color: 'grey', fontSize: 12 }}>Sign In using Email</span>
          </div>
          <div className='flex-container-row' style={{ alignItems: 'center' }}>
            <Input placeholder="Email"
                   value={this.state.email}
                   style={{ width: 210, height: 37, marginRight: 5 }}
                   className='instant-input-default'
                   onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
                  />
            <Button value="Sign In"
                    style={{ padding: 8, height: 36, width: 60, justifyContent: 'center', alignItems: 'center' }}
                    icon='fas fa-sign-in-alt'
                    className='flex-container-row'
                    loading={this.state.email_loading}
                    onClick={ () => {
                      let email = this.state.email;
                      this.props.userActions.sendSignInCodeEmail(email, this.emailCodeSuccess, this.emailCodeFailure);
                      this.setState({ ...this.state, email_loading: true });
                    }}
                  />
          </div>
        </div>

        <Line style={{ marginTop: 5, marginBottom: 0, backgroundColor: 'white' }} />

        <div className='flex-container-column'>
          <div style={{ paddingLeft: 3, marginBottom: 2 }}>
            <span style={{ color: 'grey', fontSize: 12 }}>Sign In using Text</span>
          </div>
          <div className='flex-container-row' style={{ alignItems: 'center' }}>
            <PhoneInput value={this.state.phone_number}
                        style={{ fontSize: 13 }}
                        containerStyle={{ marginRight: 5, height: 37 }}
                        onChange={ (phone_number) => { this.setState({ ...this.state, phone_number: phone_number }) }} />

            <Button value="Sign In"
                    style={{ padding: 8, height: 36, width: 60, justifyContent: 'center', alignItems: 'center' }}
                    icon='fas fa-sign-in-alt'
                    className='flex-container-row'
                    loading={this.state.phone_loading}
                    onClick={ () => {
                      let phone_number = this.state.phone_number;
                      this.props.userActions.sendSignInCodeText(phone_number, this.textCodeSuccess, this.textCodeFailure);
                      this.setState({ ...this.state, phone_loading: true });
                    }}
                  />
          </div>
        </div>

        <Line style={{ marginTop: 25, marginBottom: 5 }} />

        <div className='flex-container-row' style={{ marginTop: 10, width: '100%' }}>
          <div className='flex-container-column' style={{ alignItems: 'center', flex: 1 }}>
            <Button value="Create Provider Account"
                    style={{ paddingRight: 48, paddingLeft: 45 }}
                    onClick={ () => {
                      this.props.navigationActions.navigateTo(routes.SIGN_UP)
                    }}
                  />
          </div>
        </div>
      </div>
    );
  }

  emailCodeSuccess = (password_login) => {
    const screenProps = {
      sign_in_method: 'email',
      email: this.state.email,
      password_login: password_login,
    }
    this.setState({ ...this.state, email_loading: false });
    history.push({ pathname: routes.USER_SIGN_IN_CODE, state: { props: screenProps } })
  }

  emailCodeFailure = (message) => {
    this.setState({ ...this.state, email_loading: false });
  }

  textCodeSuccess = (password_login) => {
    const screenProps = {
      sign_in_method: 'text',
      phone_number: this.state.phone_number,
      password_login: password_login,
    }
    this.setState({ ...this.state, phone_loading: false });
    history.push({ pathname: routes.USER_SIGN_IN_CODE, state: { props: screenProps } })
  }

  textCodeFailure = () => {
    this.setState({ ...this.state, phone_loading: false });
  }

  signInAction = () => {
    const data = {
      email: this.state.email,
      password: this.state.password,
    }

    const validation = ValidatorUtils.validate('signIn', data);

    if (!validation.valid) {
      this.setState({ ...this.state, validation: validation });
      return;
    } else {
      this.setState({ ...this.state, validation: validation, loading: true });
    }

    this.performSignIn()
  }

  renderErrorMessages = (validation) => {
    var errors = validation.errors || [];
    if (errors.length > 0) {

      const errorRows = errors.map((error, index) => {
        return <span key={index} style={{ fontSize: 14, color: 'red' }}>{ error }</span>
      });

      return <div className='flex-container-column' style={{ marginBottom: 10 }}>
        { errorRows }
      </div>
    }
  }

  updateErrorMessage = (stopLoading, errorMessage) => {
    const validation = {
      errors: [errorMessage],
    }
    this.setState({ ...this.state, validation: validation, loading: !stopLoading });
  }

}


export default SignIn
